import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserJobPosts } from '~/api/jobPosts/useUserJobPosts';
import { useUser } from '~/api/user';
import { ErrorState, Pagination } from '~/components';
import { useJobPostPagination } from '~/pages/JobPosts/JobPosts.nuqs';

import { JobPostCard } from './components/JobPostCard';
import { JobPostsList } from './components/JobPostsList';
import { disclaimerStyle, itemStyle, listJobsStyle } from './JobPosts.css';

export const OwnJobPosts = () => {
  const { t } = useTranslation(['jobPosts']);
  const { data: user } = useUser();
  const [paginationQuery, setPaginationQuery] = useJobPostPagination();
  const listRef = useRef<HTMLDivElement>(null);

  const {
    data: jobPostsResponse,
    isError,
    isPending,
    isPlaceholderData,
  } = useUserJobPosts({
    userId: user.id,
    pagination: paginationQuery,
  });

  if (isError) return <ErrorState onRetry={() => window.location.reload()} title={t('jobPosts:overview.error.title')} />;

  if (isPending) return <div className={disclaimerStyle}>{t('jobPosts:overview.loading')}</div>;

  const jobPosts = jobPostsResponse?.data ?? [];
  const totalResults = jobPostsResponse?.pagination.totalResults;

  return jobPosts.length > 0 || (totalResults ?? 0) > 0 ? (
    <div className={listJobsStyle} ref={listRef}>
      <JobPostsList isLoading={isPending || isPlaceholderData}>
        {jobPosts.map((jobPost) => (
          <li className={itemStyle} key={jobPost.id}>
            <JobPostCard jobPost={jobPost} />
          </li>
        ))}
      </JobPostsList>
      <Pagination
        onChange={(newPagination) => setPaginationQuery(newPagination)}
        pageIndex={paginationQuery.pageIndex}
        pageSize={paginationQuery.pageSize}
        scrollTargetRef={listRef}
        showPageSizeOptions
        totalResults={totalResults ?? 0}
      />
    </div>
  ) : (
    <div className={disclaimerStyle}>{t('jobPosts:overview.own.empty')}</div>
  );
};
